import React from 'react';
import { NoResult, useLazyLoading, Loading } from '../_common';
import DriverItem from './DriverItem';
import { GetAllDriversMasterData_getAllDriversMasterData as Driver } from '../../types/schemaTypes';

interface DriverListProps {
    abortRequest: () => void;
    driverList: any[];
    isLoading: boolean;
    isEndOfResults: boolean;
    onLoadMore: () => void;
    canEditDrivers: boolean;
    canEditSBXDrivers: boolean;
    onEditClick: (driver: Driver) => void;
    onDelete?: (record: any) => void;
}

const DriverList = ({
    abortRequest,
    driverList,
    isLoading,
    isEndOfResults,
    onLoadMore,
    canEditDrivers,
    canEditSBXDrivers,
    onEditClick,
    onDelete,
}: DriverListProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('loadList', isLoading, isEndOfResults, onLoadMore);

    if (isLoading) {
        return (
            <div className="LoadList-Loading">
                <Loading />
            </div>
        );
    }

    const containerStyle = `DriversItem-Bottom-Container DriverList-Header ${'DriversItem-Bottom-Container-With-Background'}`;
    return (
        <div className="JobLoads-LoadList" id="loadList" onScroll={handleScroll}>
            <div className={containerStyle}>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">Name</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">RegionName</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">DistrictName</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">ISNET ID</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">IsCompliant</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">Active/Inactive Date</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">Active/Inactive User</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">CompanyName</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">DriverType</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">CellPhone</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">Pool</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">Status</div>
                </div>
                <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                    <div className="Drivers-Header-Title">Actions</div>
                </div>
            </div>
            {driverList && driverList.length === 0 ? (
                <NoResult isModal={false} />
            ) : (
                driverList.map((driver, index) => (
                    <DriverItem
                        key={driver!.driverId}
                        index={index}
                        canEditDrivers={canEditDrivers}
                        canEditSBXDrivers={canEditSBXDrivers}
                        driver={driver}
                        onEditClick={onEditClick}
                        onDelete={onDelete}
                    ></DriverItem>
                ))
            )}
        </div>
    );
};

export default DriverList;
